import gql from 'graphql-tag'

export const GET_CURRENT_TIME_SUBSCRIPTION = gql`
  subscription GetCurrentTime {
    currentTime {
      unixTime
      timeStamp
    }
  }
`

export const GET_CHAT_MESSAGES_SUBSCRIPTION = gql`
  subscription GetChatMessages {
    chatMessages {
      id
      chatId
      chatKey
      chatIndex
      projectId
      event
      content
      isFresh
      createdAt
      isCustomerOnline
      isAiControlIntercepted
    }
  }
`

export const GET_CUSTOMER_CONNECTION_STATUS_SUBSCRIPTION = gql`
  subscription GetCustomerConnectionStatus {
    customerConnectionStatus {
      chatKey
      isOnline
    }
  }
`

export const GET_CUSTOMER_TYPING_STATUS_SUBSCRIPTION = gql`
  subscription GetCustomerTypingStatus {
    customerTypingStatus {
      isTyping
      chatKey
    }
  }
`
